<div class="container">
  <div class="text-center">
    <strong style="font-size: 1.5rem; color: #8e0e00 !important">Containers</strong>
  </div>

  <div class="toolbar d-flex align-items-center justify-content-between gap-2 mb-3 mt-2">
    <div class="d-flex gap-2">
      <button class="btn btn-success" (click)="openCreateContainerModal(createContainer)" ngbTooltip="Create Container">
        <span><i class="bi bi-plus me-2"></i></span>Create
      </button>
      <button class="btn btn-success" (click)="exportToExcel()" ngbTooltip="Export to excel">
        <span><i class="bi bi-box-arrow-up me-2"></i></span>Export
      </button>
      <button class="btn btn-success" (click)="clearGrid()" ngbTooltip="Clear filter">
        <span><i class="bi bi-x-circle me-2"></i></span>Clear
      </button>
    </div>

    <div class="d-flex align-items-center gap-2">
      <label for="typeOfUser" class="mb-0">Select City</label>
      <select (change)="onFilterCityChange($event)" class="form-select w-auto">
        <option value="all">All</option>
        <option *ngFor="let city of cityList" [value]="city.id">{{ city.cityName }}</option>
      </select>

      <input type="text" class="form-control w-auto" placeholder="Search" (input)="search($event)" />
    </div>
  </div>


  <div class="card shadow-lg p-3">
    <div class="table-responsive">
      <table class="table table-striped table-bordered text-center">
        <thead class="table-light">
          <tr>
            <!-- <th class="text-center">Container ID</th> -->
            <th class="text-center">City</th>

            <!-- Container Type  Column with Dropdown Filter -->
            <th class="text-center">
              <div class="d-flex justify-content-center align-items-center">
                <span>Container Type</span>
                <div class="dropdown ms-2">
                  <i class="bi bi-funnel cursor-pointer" id="nameFilterDropdown" data-bs-toggle="dropdown"
                    aria-expanded="false" style="font-size: 1.2rem; color: #6c757d" (click)="toggleFilter('name')"></i>
                  <ul class="dropdown-menu" aria-labelledby="nameFilterDropdown">
                    <li>
                      <a class="dropdown-item" (click)="clearFilter()">All</a>
                    </li>
                    <li *ngFor="let name of uniqueContainerNames">
                      <a class="dropdown-item" (click)="filterContainerName = name; applyFilters()">{{ name }}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </th>

            <!-- Container Capacity Column with Dropdown Filter -->
            <th class="text-center">
              <div class="d-flex justify-content-center align-items-center">
                <span>Container Capacity In (m³)</span>
                <div class="dropdown ms-2">
                  <i class="bi bi-funnel cursor-pointer" id="capacityFilterDropdown" data-bs-toggle="dropdown"
                    aria-expanded="false" style="font-size: 1.2rem; color: #6c757d"
                    (click)="toggleFilter('capacity')"></i>
                  <ul class="dropdown-menu" aria-labelledby="capacityFilterDropdown">
                    <li>
                      <a class="dropdown-item" (click)="clearFilter()">All</a>
                    </li>
                    <li *ngFor="let capacity of uniqueContainerCapacities">
                      <a class="dropdown-item" (click)="
                          filterContainerCapacity = capacity; applyFilters()
                        ">{{ capacity }}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </th>
            <!-- <th class="text-center">Exact Capacity (m³)</th>
            <th class="text-center">Container Size (m³)</th> -->
            <th class="text-center">Container Dimensions(M)</th>
            <!-- <th class="text-center">Container Capacity(KG)</th> -->
            <th class="text-center">Date Created</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let container of pagedData; let i = index">
            <!-- <td>{{ container.id }}</td> -->
            <td>{{ container.cityName }}</td>
            <td>{{ container.containerName }}</td>
            <td>{{ container.containerInTons }}</td>
            <!-- <td>{{ container.containerExactCapacity }}</td>
            <td>{{ container.containerSize }}</td> -->
            <td>{{ container.containerDimensions }}</td>
            <!-- <td>{{ container.containerInPounds }}</td> -->
            <td class="w-25">
              {{ container.createdDate | date : "dd MMM yyyy" }}
            </td>
          </tr>
        </tbody>
      </table>
      <div *ngIf="allContainerList?.length === 0">
        <h3 class="text-center">No Data Found</h3>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center mt-3">
      <!-- Entries Per Page Dropdown at Start -->
      <div class="d-flex align-items-center me-3 mb-2">
        <label class="me-2 mb-0">Show</label>
        <select
          class="form-select form-select-sm text-center"
          style="width: auto; min-width: 70px;"
          [(ngModel)]="pageSize"
          (change)="onPageSizeChange()"
        >
          <option *ngFor="let size of pageSizeOptions" [value]="size">
            {{ size }}
          </option>
        </select>
        <label class="ms-2 mb-0">entries</label>
      </div>
    
      <!-- Pagination Centered -->
      <div class="d-flex justify-content-center flex-grow-1">
        <ngb-pagination
          *ngIf="allContainerList?.length > 0"
          [(page)]="page"
          [pageSize]="pageSize"
          [collectionSize]="allContainerList?.length"
          (pageChange)="onPageChange($event)"
          [boundaryLinks]="true"
        >
        </ngb-pagination>
      </div>
    
      <!-- Entries Count Message Aligned to the End -->
      <div *ngIf="allContainerList?.length > 0" class="text-muted mb-3 ms-3">
        <strong>
          Showing {{ (page - 1) * pageSize + 1 }} to
          {{
            page * pageSize > allContainerList?.length
              ? allContainerList?.length
              : page * pageSize
          }}
          of {{ allContainerList?.length }} entries
        </strong>
      </div>
    </div>
    
  </div>

  <!-- Create Containers Modal -->
  <ng-template #createContainer let-modal>
    <div class="modal-header custom-modal-header">
      <h5 class="modal-title mt-2">Create Container</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <form [formGroup]="createContainerForm">
      <div class="modal-body">
        <!-- Row 1: Container Name & Capacity -->
        <div class="row mb-3">
          <!-- City Dropdown -->
          <div class="col-md-4">
            <label for="typeOfUser">Select City</label>
            <select formControlName="cityId" (change)="onCityChange($event)" class="form-select" [ngClass]="{
              'invalid-field':
                createContainerForm.controls['cityId'].invalid &&
                createContainerForm.controls['cityId'].touched
            }">
              <option value="" disabled selected>Select City</option>
              <option *ngFor="let city of cityList" [value]="city.id">{{ city.cityName }}</option>
            </select>
          </div>


          <!-- Container Type -->
          <div class="col-md-4">
            <label for="containerName">Container Type</label>
            <input type="text" class="form-control" formControlName="containerName" placeholder="Enter Container Type"
              [ngClass]="{
                'invalid-field':
                  createContainerForm.controls['containerName'].invalid &&
                  createContainerForm.controls['containerName'].touched
              }" />
          </div>

          <!-- Container Capacity -->
          <div class="col-md-4">
            <label for="containerCapacity">Container Capacity (m³)</label>
            <input type="text" class="form-control" formControlName="containerCapacity"
              placeholder="Enter Container Capacity" [ngClass]="{
                'invalid-field':
                  createContainerForm.controls['containerCapacity'].invalid &&
                  createContainerForm.controls['containerCapacity'].touched
              }" />
          </div>
        </div>


        <!-- Row 2: Exact Capacity & Container Size -->
        <div class="row mb-3">
          <div class="col-md-6">
            <label for="containerCapacity">Exact Capacity (m³)</label>
            <input type="text" class="form-control" formControlName="volume"
              placeholder="Enter Container Capacity in m³" [ngClass]="{
                'invalid-field':
                  createContainerForm.controls['volume'].invalid &&
                  createContainerForm.controls['volume'].touched
              }" />
          </div>
          <div class="col-md-6">
            <label for="containerSize">Container Size (m³)</label>
            <input type="text" class="form-control" formControlName="containerSize"
              placeholder="Enter Container Size in m³" [ngClass]="{
                'invalid-field':
                  createContainerForm.controls['containerSize'].invalid &&
                  createContainerForm.controls['containerSize'].touched
              }" />
          </div>
        </div>

        <!-- Row 3: Length, Width, Height -->
        <div class="d-flex align-items-center justify-content-start mt-3">
          <div class="d-flex align-items-center me-3">
            <label for="length" class="me-2">Length (CM):</label>
            <input type="text" class="form-control" formControlName="length" placeholder="Length..." [ngClass]="{
                'invalid-field':
                  createContainerForm.controls['length'].invalid &&
                  createContainerForm.controls['length'].touched
              }" style="width: 120px" />
          </div>

          <div class="d-flex align-items-center me-3">
            <label for="width" class="me-2">Width (CM):</label>
            <input type="text" class="form-control" formControlName="width" placeholder="Width..." [ngClass]="{
                'invalid-field':
                  createContainerForm.controls['width'].invalid &&
                  createContainerForm.controls['width'].touched
              }" style="width: 120px" />
          </div>

          <div class="d-flex align-items-center">
            <label for="height" class="me-2">Height (CM):</label>
            <input type="text" class="form-control" formControlName="height" placeholder="Height..." [ngClass]="{
                'invalid-field':
                  createContainerForm.controls['height'].invalid &&
                  createContainerForm.controls['height'].touched
              }" style="width: 120px" />
          </div>
        </div>

        <!-- Row 4: Container Capacity in KG -->
        <div class="row mt-3">
          <div class="col-md-12">
            <label for="containerPounds">Container Capacity (KG)</label>
            <input type="text" class="form-control" formControlName="containerPounds"
              placeholder="Enter Container Capacity in KG" [ngClass]="{
                'invalid-field':
                  createContainerForm.controls['containerPounds'].invalid &&
                  createContainerForm.controls['containerPounds'].touched
              }" />
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-primary" (click)="addContainer(modal)">
          Submit
        </button>
        <button class="btn btn-secondary" (click)="modal.dismiss()">
          Cancel
        </button>
      </div>
    </form>
  </ng-template>
</div>